import axios from 'axios'
import store from '@/store'

export default () => {
  var client = axios.create({
    baseURL: process.env.VUE_APP_API_BUSINESS,
    withCredentials: false,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })

  client.interceptors.request.use(
    config => {
      return store.dispatch('Authenticate').then(user => {
        if (!user) {
          return config
        }
        if (user) {
          const authToken = user.access_token
          if (authToken) {
            config.headers.Authorization = `Bearer ${authToken}`
          }
        }
        if (store.state.admin.resellerContext) {
          config.headers.ResellerContext = store.state.admin.resellerContext
        }
      return config
      })
    },
    err => {
      // We should never arrive here
      console.error('to err is human, to forgive developers is divine', err)
    }
  )

  return client
}
